/** @jsx jsx */

import { PropsWithChildren } from 'react';

import { Colors } from '@zapier/theme';
import { css, jsx } from '@emotion/core';

const Styles = {
  root: css`
    display: inline-block;
    color: ${Colors.cyclops};
    font-size: 13px;
    font-weight: 700;
    margin-top: 10px;
  `,
};

function ErrorMessage({ children }: PropsWithChildren<{}>) {
  return <span css={Styles.root}>{children}</span>;
}

export default ErrorMessage;
